import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  Vehicle,
  VehicleCreateRequest,
  VehicleListQuery,
  VehicleListResult,
  VehiclePatchRequest,
  VehicleUpdateRequest
} from '../models/vehicle.model';

@Injectable({ providedIn: 'root' })
export class VehicleService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/vehicles`;

  getVehicles(query: VehicleListQuery = {}): Observable<VehicleListResult> {
    let params = new HttpParams();
    if (query.status) params = params.set('status', query.status);
    if (query.search) params = params.set('search', query.search);
    if (query.page) params = params.set('page', query.page);
    if (query.pageSize) params = params.set('pageSize', query.pageSize);

    return this.http.get<VehicleListResult>(this.baseUrl, { params });
  }

  getVehicleById(vehicleId: number): Observable<Vehicle> {
    return this.http.get<Vehicle>(`${this.baseUrl}/${vehicleId}`);
  }

  getAvailableVehicles(scheduledDate: string, durationMinutes: number, excludeJobId?: number): Observable<Vehicle[]> {
    let params = new HttpParams().set('scheduledDate', scheduledDate).set('durationMinutes', durationMinutes);
    if (excludeJobId) params = params.set('excludeJobId', excludeJobId);

    return this.http.get<Vehicle[]>(`${this.baseUrl}/available`, { params });
  }

  createVehicle(request: VehicleCreateRequest): Observable<Vehicle> {
    return this.http.post<Vehicle>(this.baseUrl, request);
  }

  updateVehicle(vehicleId: number, request: VehicleUpdateRequest): Observable<Vehicle> {
    return this.http.put<Vehicle>(`${this.baseUrl}/${vehicleId}`, request);
  }

  patchVehicle(vehicleId: number, request: VehiclePatchRequest): Observable<Vehicle> {
    return this.http.patch<Vehicle>(`${this.baseUrl}/${vehicleId}`, request);
  }

  deactivateVehicle(vehicleId: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${vehicleId}`);
  }
}
